import React, { useState } from "react";
import { Formik } from "formik";
import pt from "react-phone-input-2/lang/pt.json";
import {
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  Switch,
  Typography,
} from "@material-ui/core";
import { Legend } from "./styles";
import PhoneInput from "react-phone-input-2";
import { Alert, Autocomplete } from "@material-ui/lab";
import { ButtonAlert, Field } from "modules/app/pages/NewCustomer/styles";
import { useTranslation } from "react-i18next";
import { API } from "shared/services";
import { useMain, useMainState } from "modules/app/contexts";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import * as User from "modules/app/utils/models/User";

function UserForm({ id, userForm, myProfile, ...props }) {
  const country = "BR";

  const [errorRequest, setErrorRequest] = useState(null);
  const { t } = useTranslation();
  const { users, company, externalUsers } = useMainState();
  const { updateMainUsers } = useMain();
  const history = useHistory();

  const externalUser = externalUsers?.find(
    (external) => external.external_id === userForm.external_id
  );

  function traitError(error) {
    const data = error.response.data;

    if (data?.errors && Array.isArray(data?.errors)) {
      setErrorRequest({
        acesso: ["Você não tem acesso a essa equipe"],
      });
    } else {
      setErrorRequest(data);
    }

    toast.error("Não foi possível criar o usuário");
  }

  async function submitEditUser(values, { setSubmitting }) {
    try {
      const result = await API.put(`users/${id}`, {
        user: {
          ...values,
          external_id: values.external_user?.external_id || "",
        },
      });

      updateMainUsers(
        users.map((u) => {
          if (u.id == result.data.id) {
            return { ...u, ...result.data };
          }

          return { ...u };
        })
      );

      toast.success("Usuário atualizado com sucesso");
      setErrorRequest(null);
    } catch (error) {
      traitError(error);
    }

    setSubmitting(false);
  }

  async function submitNewUser(values, { setSubmitting }) {
    values.company_id = company.id;

    try {
      const result = await API.post(`users`, {
        user: {
          ...values,
          external_id: values.external_user?.external_id || "",
        },
      });

      updateMainUsers([...users, result.data]);
      toast.success("Usuário criado com sucesso");
      history.push(`/app/users/${result.data.id}`);
      setErrorRequest(null);
    } catch (error) {
      traitError(error);
    }

    setSubmitting(false);
  }

  return (
    <Formik
      {...props}
      initialValues={{
        name: userForm.name,
        email: userForm.email,
        phone1: userForm.phone1,
        signature: userForm.signature,
        receive_lead: userForm.receive_lead,
        role: userForm.role,
        company_team_ids: userForm?.company_team_ids || [],
        status: userForm.status,
        external_user: externalUser,
        password: "",
        passwordConfirmation: "",
      }}
      validationSchema={User.validation(t, id)}
      onSubmit={id ? submitEditUser : submitNewUser}
    >
      {({
        values,
        isSubmitting,
        handleSubmit,
        handleChange,
        errors,
        setFieldValue,
      }) => (
        <>
          {errorRequest && (
            <Alert
              variant="outlined"
              severity="error"
              style={{ marginBottom: 10 }}
            >
              Erro ao criar novo usuário:
              {typeof errorRequest === "object" &&
                Object.keys(errorRequest).map((key) => (
                  <div style={{ paddingTop: 22 }} key={key}>
                    {key}:
                    <ul style={{ margin: 10 }}>
                      {Array.isArray(errorRequest[key]) &&
                        errorRequest[key].map((message) => (
                          <li key={message}>{message}</li>
                        ))}
                    </ul>
                  </div>
                ))}
            </Alert>
          )}

          <Divider style={{ marginBottom: 30 }} />

          <FormControl component="fieldset" variant="outlined">
            <Legend>Dados do usuário</Legend>

            <Field
              name="name"
              label="Nome"
              variant="outlined"
              value={values.name || ""}
              onChange={handleChange}
              helperText={errors.name}
            />

            <Field
              name="email"
              label="E-mail"
              variant="outlined"
              value={values.email || ""}
              onChange={handleChange}
              helperText={errors.email}
            />

            <PhoneInput
              enableSearch
              country={country.toLowerCase()}
              value={values.phone1}
              specialLabel="Telefone"
              inputProps={{ name: "phone1" }}
              onChange={(_phoneNumber, _country, e) => {
                handleChange(e);
              }}
              isValid={!errors.phone1}
              localization={pt}
            />
            {errors.phone1 && (
              <FormHelperText error={true}>{errors.phone1}</FormHelperText>
            )}

            <Field
              multiline
              name="signature"
              label="Assinatura"
              variant="outlined"
              rows={5}
              rowsMax={10}
              onChange={handleChange}
              value={values.signature || ""}
            />
          </FormControl>

          {(id || myProfile) && (
            <FormControl component="fieldset" variant="outlined">
              <Legend>Alterar senha</Legend>

              <Field
                name="password"
                label="Senha"
                variant="outlined"
                value={values.password}
                type="password"
                onChange={handleChange}
                helperText={errors.password}
              />

              <Field
                name="passwordConfirmation"
                label="Verificar senha"
                variant="outlined"
                value={values.passwordConfirmation}
                type="password"
                onChange={handleChange}
                helperText={errors.passwordConfirmation}
              />
            </FormControl>
          )}

          {!myProfile && (
            <>
              <FormControl component="fieldset" variant="outlined">
                <Legend>Equipes</Legend>

                <FormGroup row>
                  {company?.company_teams?.map((team) => (
                    <FormControlLabel
                      key={team.id}
                      value="company_team_ids"
                      name={team.name}
                      control={<Checkbox color="primary" name={team.name} />}
                      label={team.name}
                      disabled={
                        values.company_team_ids.length == 1 &&
                        values.company_team_ids.includes(team.id)
                      }
                      checked={values.company_team_ids.includes(team.id)}
                      onClick={() => {
                        if (values.company_team_ids.includes(team.id)) {
                          setFieldValue("company_team_ids", [
                            ...values.company_team_ids.filter(
                              (id) => id != team.id
                            ),
                          ]);
                        } else {
                          setFieldValue("company_team_ids", [
                            ...values.company_team_ids,
                            team.id,
                          ]);
                        }
                      }}
                    />
                  ))}
                </FormGroup>
              </FormControl>
              <FormControl component="fieldset" variant="outlined">
                <Legend>Configurações</Legend>

                <div>
                  <FormLabel component="label">Perfil</FormLabel>

                  <Typography component="div">
                    <Grid
                      component="label"
                      container
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>Usuário</Grid>
                      <Grid item>
                        <Switch
                          color="primary"
                          checked={values.role == "manager"}
                          onChange={() =>
                            setFieldValue(
                              "role",
                              values.role === "manager" ? "seller" : "manager"
                            )
                          }
                          name="role"
                        />
                      </Grid>
                      <Grid item>Gerente</Grid>
                    </Grid>
                  </Typography>
                </div>

                <div style={{ marginTop: 10 }}>
                  <FormLabel component="label">Recebe leads</FormLabel>

                  <Typography component="div">
                    <Grid
                      component="label"
                      container
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>Não</Grid>
                      <Grid item>
                        <Switch
                          color="primary"
                          checked={values.receive_lead}
                          onChange={() =>
                            setFieldValue("receive_lead", !values.receive_lead)
                          }
                          name="receive_lead"
                        />
                      </Grid>
                      <Grid item>Sim</Grid>
                    </Grid>
                  </Typography>
                </div>

                <div style={{ marginTop: 10 }}>
                  <FormLabel htmlFor="status" component="span">
                    Ativado
                  </FormLabel>

                  <Typography component="div">
                    <Grid
                      component="label"
                      container
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>Não</Grid>
                      <Grid item>
                        <Switch
                          color="primary"
                          checked={values.status === "active"}
                          onChange={() => {
                            values.status === "active" &&
                              toast.warn(
                                "Se você salvar esse usuário como desativado ele não poderá mais acessar o sistema."
                              );

                            setFieldValue(
                              "status",
                              values.status === "active" ? "disabled" : "active"
                            );
                          }}
                          name="status"
                        />
                      </Grid>
                      <Grid item>Sim</Grid>
                    </Grid>
                  </Typography>
                </div>
              </FormControl>
              <FormControl component="fieldset" variant="outlined">
                <FormLabel component="legend"> Integrações </FormLabel>

                <Autocomplete
                  value={values.external_user}
                  id="external_user"
                  options={externalUsers || []}
                  getOptionLabel={(externalUser) => externalUser.name}
                  fullWidth
                  getOptionSelected={(option, value) =>
                    option?.external_id === value?.external_id
                  }
                  onChange={(_event, externalUser) =>
                    setFieldValue("external_user", externalUser)
                  }
                  renderInput={(params) => (
                    <Field
                      {...params}
                      label="Usuário externo"
                      variant="outlined"
                      helperText={errors.external_user}
                    />
                  )}
                />
              </FormControl>
            </>
          )}

          <ButtonAlert
            color="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
            variant="contained"
          >
            {isSubmitting ? (
              <CircularProgress />
            ) : id ? (
              "Alterar usuário"
            ) : (
              "Criar usuário"
            )}
          </ButtonAlert>
        </>
      )}
    </Formik>
  );
}

export default UserForm;
